import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_USER = createActionTypes('FETCH_USER');
export const CREATE_USER = createActionTypes('CREATE_USER');
export const UPDATE_USER = createActionTypes('UPDATE_USER');
export const DELETE_USER = createActionTypes('DELETE_USER');
export const CHANGE_ROLE = createActionTypes('CHANGE_ROLE');
export const FETCH_FLEET_MEMBERS = createActionTypes('FETCH_FLEET_MEMBERS');
export const UPDATE_USER_GST = createActionTypes('UPDATE_USER_GST');
export const GET_USER = createActionTypes('GET_USER');
export const TOGGLE_INDEPENDENT_WALLET = createActionTypes('TOGGLE_INDEPENDENT_WALLET');
